import {FILE_KEYS} from "../helpers/consts";
import {CLUSTERS_COLORS_MAP} from "../helpers/colors";
import {getAlaSQLPromise} from "../helpers/sqlHelper";

export const DATA_REQUEST_ACTION = "DATA_REQUEST";
export const DATA_RECEIVED_ACTION = "DATA_RECEIVED";
export const DATA_FAIL_ACTION = "DATA_FAIL";

export const SET_MAP_DATA_ACTION = "SET_MAP_DATA";
export const SET_MAP_VIEWPORT_ACTION = "SET_MAP_VIEWPORT"

export const START_OVER_MAP = "START_OVER_MAP";
export const SET_MAP_ZOOM = "SET_MAP_ZOOM";
export const SET_MAP_CENTER = "SET_MAP_CENTER";
export const SET_DEFAULT_VIEWPORT_MAP = "SET_DEFAULT_VIEWPORT_MAP";


export const setMapDataAction = (view, filter, field, entity) => dispatch => {
  return dispatch({
    type: SET_MAP_DATA_ACTION,
    payload: {view, filter, field, entity}
  });
};

export const setMapViewportAction = (viewport) => dispatch => {
  return dispatch({
    type: SET_MAP_VIEWPORT_ACTION,
    payload: {viewport}
  });
};

const BASE_URL = window.FOW_BASE_URL && window.FOW_BASE_URL !== '<FOW_BASE_URL>' ? window.FOW_BASE_URL : "./";

const files_available = {
  [FILE_KEYS.ISCO_REFERENCE]:{
    name: 'ISCO References',
    file: `${BASE_URL}data/0-isco-reference.csv`,
    parser: 'csv',
    group: 'dimensions',
    parse: (data) => data
  },
  [FILE_KEYS.NACE_REFERENCE]: {
    name: 'NACE References',
    file: `${BASE_URL}data/0-nace-reference.csv`,
    parser: 'csv',
    group: 'dimensions',
    parse: (data) => data
  },
  [FILE_KEYS.CLUSTERS_REFERENCE]: {
    name: 'Regional Clusters',
    file: `${BASE_URL}data/1-regional-clusters-metadata.csv`,
    parser: 'csv',
    group: 'dimensions',
    parse: (data) => data.map(cluster => {
        cluster.color = CLUSTERS_COLORS_MAP[cluster.cluster_name] ? CLUSTERS_COLORS_MAP[cluster.cluster_name]:"#ccc";
        return cluster;
      })
  },
  [FILE_KEYS.COUNTRIES_REFERENCE]: {
    name: 'Countries',
    file: `${BASE_URL}data/3-country-codes-reference.csv`,
    parser: 'csv',
    group: 'dimensions',
    parse: (data) => data
  },
  [FILE_KEYS.URBAN_REFERENCE]: {
    name: 'Urban Typologies',
    file: `${BASE_URL}data/3-urban-typology-reference.csv`,
    parser: 'csv',
    group: 'dimensions',
    parse: (data) => data
  },
  [FILE_KEYS.NUTS3_SHAPES]: {
    name: 'NUTS3 Geo shapes',
    file: `${BASE_URL}data/1-nuts3-shapes-metro-cluster.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.EMPLOYMENT_DATA]: {
    name: 'Employment data',
    file: `${BASE_URL}data/2-employment-data.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.OCCUPATIONAL_DATA]: {
    name: 'Occupational data',
    file: `${BASE_URL}data/4-occupational-data.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.OCCUPATIONAL_TOP10_CHANGES]: {
    name: 'Occupational changes data',
    file: `${BASE_URL}data/4-top10-occupations-changes-data.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.OCCUPATIONAL_TOP10_SHARE]: {
    name: 'Occupational shares data',
    file: `${BASE_URL}data/4-top10-occupations-share-data.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.OCCUPATIONAL_EU]: {
    name: 'Occupational change EU wide',
    file: `${BASE_URL}data/2-eu-occupations-growth-decline.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.OCCUPATIONAL_CLUSTERS]: {
    name: 'Occupational change by clusters',
    file: `${BASE_URL}data/1-occupation-growth-by-cluster.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.METRO_STATS]: {
    name: 'Metro statistics',
    file: `${BASE_URL}data/3-metro-stats-data.csv`,
    parser: 'csv',
    group: 'dimensions',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.NUTS3_PRESENT]: {
    name: 'NUTS3 present data',
    file: `${BASE_URL}data/3-labor-nuts3-present-data.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data.map(r=>{
        delete r.id;
        delete r.cluster_id;
        return r;
      });
    }
  },
  [FILE_KEYS.CLUSTERS_AVG_PRESENT]: {
    name: 'Clusters AVG Present data',
    file: `${BASE_URL}data/3-labor-cluster-averages-present-data.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.NUTS3_FUTURE]: {
    name: 'NUTS3 future data',
    file: `${BASE_URL}data/3-labor-nuts3-future-data.csv`,
    parser: 'csv',
    group: 'facts',
    parse: (data, dispatch) => {
      return data;
    }
  },
  [FILE_KEYS.NUTS3_TOP_OCCUPATIONS_FUTURE]: {
    name: 'Top occupations future',
    file: `${BASE_URL}data/3-top-occupations-2018-30-future-data.csv`,
    parser: 'csv',
    group: 'toJoin',
    parse: (data, dispatch) => {
      return data.map(r => {
        r.trend = r.indicator.split('-')[1];
        r.indicator = parseInt(r.indicator.split('-')[0]);
        r.isco_2_id = r.occupation;
        delete r.occupation;
        return r;
      });
    }
  }
}

export const loadDataAction = (keys, db) => dispatch => {
  //Load data by ALA
  keys.forEach(key => {
    if (files_available[key]) {
      const config = files_available[key];

      if (!(db.data.dimensions[key] || db.data.facts[key] || db.data.toJoin[key])){
        dispatch({
          type: DATA_REQUEST_ACTION,
          payload: {key, name: config.name}
        });

        const getQueryToLoad = getAlaSQLPromise(config);

        getQueryToLoad
          .then(function (data) {
              dispatch({
                type: DATA_RECEIVED_ACTION,
                payload: {
                  data: config.parse(data, dispatch),
                  group: config.group,
                  key: key
                }
              });
          }).catch(function (error) {
            console.error('3. Error loading '+key, error)
            dispatch({
              type: DATA_FAIL_ACTION,
              payload: error
            });
          });
      } else {
        console.log(key+' already loaded!');
      }

    } else {
      console.error('Trying to load wrong dataset key:' + key);
    }
  });
};

export const startOverMapAction = () => dispatch => {
  return dispatch({
    type: START_OVER_MAP
  });
};

export const setMapZoomAction = (zoomIn) => dispatch => {
  return dispatch({
    type: SET_MAP_ZOOM,
    payload: {zoomIn}
  });
};


export const setMapCenterAction = (item) => dispatch => {
  return dispatch({
    type: SET_MAP_CENTER,
    payload: {item}
  });
};

export const setDefaultViewportAction = (viewport) => dispatch => {
  return dispatch({
    type: SET_DEFAULT_VIEWPORT_MAP,
    payload: {viewport}
  });
};

